import React from 'react'
import { useParams } from 'react-router-dom'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'

import MarketingContent, { LearnMoreLink, MarketingQuestionAndAnswer } from '@sputnik/components/MarketingContent'
import { getIsDSABusinessOnly } from '@sputnik/components/utils'
import useGetIsLoggedInAsAuthSigner from '@sputnik/hooks/useGetIsLoggedInAsAuthSigner'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import { useGetPeopleInfoMarketingContentData } from './GetPeopleInfoMarketingContentData.gql'

const AuthorizedSignerFormMarketingContent = () => {
  const { appId } = useParams()
  const { formatMessage } = useIntl()
  const { tracker } = useWebTracking()
  const { data } = useGetPeopleInfoMarketingContentData({
    variables: {
      creditApplicationId: appId ?? '',
    },
  })
  const { isLoggedInUserAuthorizedSigner } = useGetIsLoggedInAsAuthSigner({
    authSignerEmail: data?.creditApplication?.authorizedSigner?.email || '',
  })

  const shouldShowSoftCreditPullContent =
    isLoggedInUserAuthorizedSigner && !getIsDSABusinessOnly(data?.creditApplication?.dsaVersion)

  return (
    <MarketingContent
      footer={
        shouldShowSoftCreditPullContent && (
          <LearnMoreLink onClick={() => tracker?.track('se_signup__add_people_learn_more__fired')} />
        )
      }
      image={{
        alt: formatMessage({
          defaultMessage: 'person tapping a Bill branded credit card on a credit card reader',
          id: 'sputnik.PeopleInfoFormMarketingContent__YWLV+D',
        }),
        src: 'https://app.divvy.co/assets/stock-photos/credit-application-authorized-signer-marketing-content.png',
      }}
      pillText={
        <FormattedMessage
          defaultMessage='Pro tip'
          id='sputnik.PeopleInfoFormMarketingContent__0oV4Vc'
        />
      }
    >
      <MarketingQuestionAndAnswer
        answer={
          <FormattedMessage
            defaultMessage='An authorized signer is a control person or beneficial owner with significant responsibility to control, manage, or direct the company. E.g CEO, CFO, COO, managing member, general partner, president, vice president, treasurer or any other individual who regularly performs similar functions. This individual should have the ability to enter into this relationship and agreement.'
            id='sputnik.PeopleInfoFormMarketingContent__j6WAd6'
          />
        }
        question={
          <FormattedMessage
            defaultMessage='What is an authorized signer?'
            id='sputnik.PeopleInfoFormMarketingContent__yc1NAt'
          />
        }
      />
      {shouldShowSoftCreditPullContent && (
        <MarketingQuestionAndAnswer
          answer={
            <FormattedMessage
              defaultMessage='Once your application is submitted, we will perform a soft inquiry of the business and the authorized signer’s personal credit to determine the best credit limit for your business. This will not affect your business credit score or the Authorized signer’s credit score. Learn more here.'
              id='sputnik.PeopleInfoFormMarketingContent__6lc4el'
            />
          }
          question={
            <FormattedMessage
              defaultMessage='We do not do a hard inquiry or “hard pull” of your business credit.'
              id='sputnik.PeopleInfoFormMarketingContent__x15PVW'
            />
          }
        />
      )}
    </MarketingContent>
  )
}

export default AuthorizedSignerFormMarketingContent
